import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import error from '../../../../common/nodejs/errors';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';

/** 開始処理 */
export async function start(self) {
  try {
    self.isLoading = true;
    //バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'start',
      },
      // エラー発生のコールバックを実装
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    if (response) {
      // 正常コールバック
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 正常終了
          // 結果に関わらず、セッション遷移済フラグを取得
          self.sessionTransitionFlag = response.data?.user_data?.session_transition_flag;
          // 周期通信最大時間を取得
          self.waitingTime = response.data.user_data.waiting_time;
          // 周期通信開始・取得処理
          self.isLoading = false;
          await self.executeProcess();
          break;
        case REQUEST_STATUS_FAILED:
          // 異常終了
          // 結果に関わらず、セッション遷移済フラグを取得
          self.sessionTransitionFlag = response.data?.user_data?.session_transition_flag;
          switch (response.data.async_code) {
            case error.WSP_146_SESSION_ERROR:
              // NonDefaultSession遷移エラー・セキュリティアクセスエラーの場合、エラーへ遷移
              self.showUnexpectedError();
              break;
            case error.WSP_146_PDID_CREATE_ERROR:
              // PDID生成エラーの場合、周期通信停止（異常）処理
              await self.communicationStopErrorProcess();
              break;
            case error.WSP_GENERAL_ERROR:
            default:
              // 異常終了：エラー(ありえないが定義しておく)
              self.showUnexpectedError();
              break;
          }
          break;
        default:
          // 異常終了：エラー
          self.showUnexpectedError();
          return;
      }
    }
  } finally {
    self.isLoading = false;
  }
}